export default function RadioInputGroup({ children, onChange }) {
  return (
    <div onChange={(e) => onChange(e.target.value)}>{children}</div>
  );
}
